import tw, { TwStyle } from 'twin.macro';
import {
  bgColors,
  getTextColorFromBackgroundColor,
} from '@teetsh/app/src/components/colors';
import React from 'react';
import { Color } from '@teetsh/app/src/types/colors';
import { TagColorWithIntensity } from '@teetsh/app/src/styles/userConstants';

type Variant = 'default' | 'light';

interface Props {
  value: string;
  details?: React.ReactNode;
  color: Color | TagColorWithIntensity;
  shouldStretch?: boolean;
  stripedBackground?: boolean;
  variant?: Variant;
}

const fontSize: { [K in Variant]: TwStyle } = {
  default: tw`text-base`,
  light: tw`text-sm`,
};
const fontWeight: { [K in Variant]: TwStyle } = {
  default: tw`font-semibold`,
  light: tw`font-normal`,
};

export function HeaderItem(props: Props) {
  const {
    value,
    details,
    color,
    shouldStretch,
    stripedBackground,
    variant = 'default',
  } = props;
  return (
    <div
      css={[
        tw`px-4 py-2 rounded-lg relative flex items-center gap-x-2 flex-wrap`,
        bgColors(color),
        getTextColorFromBackgroundColor(color),
        shouldStretch && tw`h-full`,
        stripedBackground &&
          tw`bg-[repeating-linear-gradient( -45deg, rgba(0, 0, 0, 0.0) 0px 5px, rgba(0, 0, 0, 0.1) 5px 10px )]`,
        fontSize[variant],
        fontWeight[variant],
      ]}
    >
      <div tw="shrink-0 truncate max-w-full">{value}</div>
      <span tw="text-xs font-light">{details}</span>
    </div>
  );
}
